import React, { useEffect } from "react";
import Careerbanner from "./Careerbanner";
import Careeroffer from "./Careeroffer";
import Careerwhy from "./Careerwhy";
import Careerform from "./Careerform";
import Careerexplore from "./Careerexplore";
import Careeropp from "./Careeropp";

const Careerpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Careerbanner/>
<Careerexplore/>
      {/* <Careeroffer/> */}
       <Careeropp/>
      <Careerwhy/>
      
       <div id="career-form-section">
        <Careerform/>
      </div>
      <br></br>
    </div>
  );
};

export default Careerpage;
